import axios from 'axios';
import moment from 'moment';

import * as actions from '../api';
// import auth from '../../helpers/authService';
// const apiToken = process.env.REACT_APP_API_TOKEN;
import config from '../../config/config';

const api = ({ dispatch, getState }) => next => async action => {
  if (action.type !== actions.apiCallBegan.type) return next(action);

  const {
    url,
    method,
    data,
    onStart,
    onSuccess,
    onError,
    actionName,
    params
  } = action.payload;

  // Выполняем само событие
  next(action);

  // Проверим есть ли данные в кеше
  const apiState = getState().api;
  const hasCache = checkDataInCache(actionName, apiState);
  // console.log('hasCache', hasCache);
  // if (hasCache) return next(action);
  if (hasCache) return;

  // Отправляем евент о начале загрузки
  dispatch({ type: actions.callRequested.type, payload: action.payload });
  // dispatch({ type: actions.callRequested.type, action });

  // Отправляем событие о старте если оно явно указанно
  if (onStart) dispatch({ type: onStart });

  do {
    // Пробуем сделать запрос
    try {
      const response = await makeRequest(url, method, data);
      // Specific
      // Если есть onSuccess то после выполнения функции нужно вызвать диспатч с этим именем если onSuccess то просто вернуть значение
      let onSuccessResult;
      if (onSuccess) {
        onSuccessResult = await dispatch({
          type: onSuccess,
          payload: { data: response.data, params }
        });
      } else {
        // dispatch({ type: actions.callSuccess.type, payload: action.payload });
        return response.data;
      }
      // General
      const generalResult = await dispatch({
        type: actions.callSuccess.type,
        payload: action.payload
      });
      return onSuccess ? onSuccessResult : generalResult;
    } catch (error) {
      // Specific
      if (onError) dispatch({ type: onError, payload: error.message });

      return dispatch({
        type: actions.callFailed.type,
        payload: { data: action.payload, error: error.message }
      });
      // return Promise.reject(error);
    }
  } while (true);
};

// Вспомогательные функции
const makeRequest = async (url, method, data) => {
  return await axios.request({
    url,
    method,
    data
  });
};

const checkDataInCache = (actionName, apiState) => {
  // console.log('checkDataInCache actionName, apiState', actionName, apiState);
  if (!(actionName in config.cache)) return false;

  if (actionName in apiState.requests) {
    const { lastFetch } = apiState.requests[actionName];
    // console.log('checkDataInCache lastFetch', lastFetch);
    const diffInMinutes = moment().diff(moment(lastFetch), 'minutes');
    // console.log('checkDataInCache diffInMinutes', diffInMinutes);
    if (diffInMinutes <= config.cache[actionName]) return true;
  }
  return false;
};

export default api;
